export enum HeatmapGradientType {
  Default = 0,
  DeepSea = 1,
  VisibleSpectrum = 2,
  BlueRed = 3,
  HeatedMetal = 4,
  NightVision = 5
}

// * NOTE - first entry for gradient colors needs to have alpha value of 0, otherwise fills the whole map with color
export const HeatmapGradientMap = {
  // matches default gradient for Google Maps Heatmap
  // need this for control display in LSD
  [HeatmapGradientType.Default]: [
    'rgba(102, 255, 0, 0)',
    'rgba(102, 255, 0, 1)',
    'rgba(147, 255, 0, 1)',
    'rgba(193, 255, 0, 1)',
    'rgba(238, 255, 0, 1)',
    'rgba(244, 227, 0, 1)',
    'rgba(249, 198, 0, 1)',
    'rgba(255, 170, 0, 1)',
    'rgba(255, 113, 0, 1)',
    'rgba(255, 57, 0, 1)',
    'rgba(255, 0, 0, 1)'
  ],
  [HeatmapGradientType.DeepSea]: [
    'rgba(0, 0, 0, 0)',
    'rgba(0, 0, 0, 1)',
    'rgba(24, 53, 103, 1)',
    'rgba(46, 100, 158, 1)',
    'rgba(23, 173, 203, 1)',
    'rgba(0, 250, 250, 1)'
  ],
  [HeatmapGradientType.VisibleSpectrum]: [
    'rgba(255, 0, 255, 0)',
    'rgba(255, 0, 255, 1)',
    'rgba(0, 0, 255, 1)',
    'rgba(0, 255, 0, 1)',
    'rgba(255, 255, 0, 1)',
    'rgba(255, 0, 0, 1)'
  ],
  [HeatmapGradientType.BlueRed]: [
    'rgba(0, 255, 255, 0)',
    'rgba(0, 255, 255, 1)',
    'rgba(0, 191, 255, 1)',
    'rgba(0, 127, 255, 1)',
    'rgba(0, 63, 255, 1)',
    'rgba(0, 0, 255, 1)',
    'rgba(0, 0, 223, 1)',
    'rgba(0, 0, 191, 1)',
    'rgba(0, 0, 159, 1)',
    'rgba(0, 0, 127, 1)',
    'rgba(63, 0, 91, 1)',
    'rgba(127, 0, 63, 1)',
    'rgba(191, 0, 31, 1)',
    'rgba(255, 0, 0, 1)'
  ],
  [HeatmapGradientType.HeatedMetal]: [
    'rgba(0, 0, 0, 0)',
    'rgba(0, 0, 0, 1)',
    'rgba(128, 0, 128, 1)',
    'rgba(255, 0, 0, 1)',
    'rgba(255, 255, 0, 1)',
    'rgba(255, 255, 255, 1)'
  ],
  [HeatmapGradientType.NightVision]: [
    'rgba(33, 59, 27, 0)',
    'rgba(33, 59, 27, 1)',
    'rgba(0, 128, 0, 1)',
    'rgba(0, 255, 0, 1)',
    'rgba(186, 255, 167, 1)',
    'rgba(255, 255, 255, 1)'
  ]
};

export const HeatmapGradientList = Object.entries(HeatmapGradientMap).map(([type, values]) => ({
  type,
  gradientValues: values.slice(-1 * (values.length - 1))
}));
